/**
 * Панцирниковые — 2 видов.
 *
 * ⚠️ ПОМЕТКИ «── ГДЕ ВОДИТСЯ ──» ПЕРЕЕХАЛИ СЮДА ВМЕСТЕ С РЫБОЙ. Вторая сотня
 * набиралась по краям света, и в прежнем файле виды стояли блоками: Иберия,
 * Балканы, Восточная Азия. Разрез по семействам эти блоки разнёс бы по
 * девятнадцати файлам, и знание о том, откуда вид, пропало бы вовсе — в коде
 * его больше нигде нет. Поэтому пометка идёт за своей рыбой.
 */
export const ПАНЦИРНИКОВЫЕ = [
    // ── Северная Америка ──
    {
        id: 'longnose_gar',
        семейство: 'панцирниковые',
        latin: 'Lepisosteus osseus',
        повадка: 'засадный',
        minKg: 0.5,
        maxKg: 6,
        typicalKg: 2.5,
        typicalLengthM: 0.9,
        depthM: 2,
        depthBandM: 1.5,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 12, опт: 26, макс: 34 },
        течение: 'слабое',
        держится: ['поверхность', 'трава', 'коряги'],
        стая: 'малая_стая',
        зубы: true,
        нерест: { с: 5, по: 6 },
        чем: [
            { чем: 'живец', вес: 1 },
            { чем: 'резка', вес: 0.6 },
            { чем: 'мушка', вес: 0.6 },
            { чем: 'spinner', вес: 0.4 },
            { чем: 'wobbler', вес: 0.4 },
        ],
    },
    {
        id: 'alligator_gar',
        семейство: 'панцирниковые',
        latin: 'Atractosteus spatula',
        повадка: 'тропический_гигант',
        minKg: 8,
        maxKg: 70,
        typicalKg: 25,
        typicalLengthM: 1.8,
        depthM: 4,
        depthBandM: 3,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'редкая',
        когда: 'ночная',
        вода: { мин: 14, опт: 28, макс: 35 },
        течение: 'слабое',
        держится: ['яма', 'поверхность', 'коряги'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 4, по: 6 },
        чем: [
            { чем: 'резка', вес: 1 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'мушка', вес: 0.4 },
            { чем: 'jig', вес: 0.2 },
        ],
    },
];
//# sourceMappingURL=lepisosteids.js.map